import type { FaireProductEntity } from "../../entity_types/product";

export const p_mhbj677rz2: FaireProductEntity = {
  token: "p_mhbj677rz2",
  type: "product",
  name: "Tinted Mineral Foundation - 31% Zinc Oxide - FREE DISPLAYS!",
  brandToken: "b_f2ec5373",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e511bc4542e9f6fae7394f7f94ade175a7d19e23d28fded2cc1fe5004883fa0c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/612c9dc8cfd38e8639874029254170147e1165cf5a9927ad535e47d183d1484f.png",
    "https://cdn.faire.com/fastly/aca935de3597c05ffd49d08cd0d2b50097f2e0ea4587e986208d3685dfbaa1fa.jpeg",
    "https://cdn.faire.com/fastly/f50df09c0fa027d0cfe13a900fdb6026e4c4a9a41af1448fb9f00d4d0de89632.png",
    "https://cdn.faire.com/fastly/69d4828c32a086e002777edbb4cb6bc251344de699487d86055eb03339bcc7b0.jpeg",
    "https://cdn.faire.com/fastly/c5b14f2f7e208ffcf252251718c87e9976a575d89c6e105c151d782c22118a86.png",
    "https://cdn.faire.com/fastly/0cbce82f03cfa2de4b52b4a128d8169ca6b89838620a4ad2ef7ccd344e563cc8.png",
  ],
  priceDollars: 12.47,
  description:
    'NEW LOOK! \nFRESH from the hive! Our brand-NEW Tinted Mineral Foundation is the perfect Mineral Makeup and Mineral Sunscreen in one! Blends bee-utifually with skin tone and provides SAFE and ocean-friendly coverage. \n.\nMade with 31% Natural Sunscreen Minerals, Iron Oxide for Color, and all organic ingredients.  NEVER any toxic dyes or chemical UV filters.\n.\nInstructions: Use stick to apply evenly and generously to face before going outside or as Mineral Makeup Foundation after moisturizing. \n.\nPro-Tip: Apply to eyelids for the perfect "natural-look" eye shadow!\n\nIngredients: 31% Zinc Oxide (Non-Nano), *Cucurbita maxima (Pumpkin Seed) Oil, *Helianthus annuus (Sunflower) oil, *Carthamus tinctorius (Safflower) Oil, *Cera alba (Beeswax), Vitamin E (non-GMO), Iron Oxides (natural color)\n*Organic Ingredient\n\nImportant Disclaimer: Not evaluated for SPF. This product is not intended to treat, cure or prevent any disease. \n\nFREE Display with 3 of Each Tint in a single container type (12 Total)!',
  tags: [],
  msrpDollars: 24.94,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:04.166Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
